// extracted by mini-css-extract-plugin
export default {"container":"style_container__Qwhyl","header":"style_header__oTxTH","content":"style_content__r7wb7","childContainer":"style_childContainer__d-Nko","child":"style_child__ie1Ic"};